/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import axios from "axios";
import { TextField, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import LabelledField from "components/labelled-field/index";
import { IconDisplay } from "cms/icons/fa-icon/icon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// FIXME: investigate broken setup
//   https://fontawesome.com/v5/docs/web/other-topics/troubleshoot#your-cdn-isn-t-working-on-my-site-or-app-what-gives
//   https://fontawesome.com/docs/web/add-icons/how-to
//   https://fontawesome.com/docs/apis/graphql/objects#icon
//   https://fontawesome.com/docs/apis/graphql/query-fields

const FontAwesomeIconWrapper = (props) => {

    const icon = props?.icon;
    const setIcon = props?.setIcon;
    const onChangeIcon = props?.onChangeIcon; 
    
    const version = "6.0.0";
    const qty = "10";
    const theme = useTheme();
    const activeColor = theme.palette.primary.main;
    const inactiveColor = theme.palette.grey[100];
    
    async function makeSearchRequest () {
        const data = JSON.stringify({
            query: `query { search (version: "${version}", query: "${query}", first: ${qty}) { id } }`,
        });

        const config = {
            method: "post",
            url: "https://api.fontawesome.com",
            headers: { "Content-Type": "application/json" },
            data: data,
        };

        const response = await axios(config);
        return response.data.data.search;
    }

    const [query, setQuery] = useState();
    const [icons, setIcons] = useState([]);
    const [selectedIcon, setSelectedIcon] = useState(icon || "");
    const setIconChoice = (choice) => {
        setSelectedIcon(choice);
        setIcon(choice);
        onChangeIcon(choice);
    };
    const runSearchQuery = (e) => {
        const queryTerm = e.target.value;
        setQuery(queryTerm);
    };

    useEffect(() => {
        const run = async () => {
            if (query?.length > 2) {
                const data = await makeSearchRequest();
                setIcons(data);
            } else {
                setIcons([]);
            }
        };
        run();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);

    return (
        <div className='icon-selector-wrapper'>
            <div className='icon-selector-search-display'>
                <div>
                    <LabelledField label='Selected Icon:'>
                        <IconDisplay
                            icon={selectedIcon}
                        />
                    </LabelledField>
                </div>
                {/*<div style={{ marginBottom: '16px' }} />*/}
                <div>
                    <LabelledField label='Search:'>
                        <TextField
                            style={{ width: "100%" }}
                            type='text'
                            onChange={(event) => runSearchQuery(event)}
                        />
                    </LabelledField>
                </div>
            </div>
            <div
                className={"simplicity-awesome-icons-list"}
                // style={{ gap: '1em', paddingTop: '2em', border: '1px solid magenta' }}
            >
                {icons.map((choice, idx) => {
                    return (
                        <div
                            key={`icon-${idx}`}
                            className='icon-selector-item'
                            onClick={() => setIconChoice(`fa-${choice.id}`)}
                        >
                            <FontAwesomeIcon
                                icon={`fa-solid fa-${choice.id}`}
                                size={"lg"}
                                style={{
                                    fontSize: "4em",
                                    color: icon ? activeColor : inactiveColor,
                                }}
                            />
                            <div style={{ paddingTop: "1em" }}>{`fa-${choice.id}`}</div>
                        </div>
                    );
                })}
                {icons.length === 0 && (
                    <Typography variant={"h4"} color={theme.palette.grey[400]}>
                        No icons match your search criteria
                    </Typography>
                )}
            </div>
        </div>
    );
};

export { FontAwesomeIconWrapper };
